/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

const Root = (props:any) => {
    const {node, children} = props
    return (
        <div className={`root`}>
            { node.title && <h2 className="text-xl">{node.title}</h2> }
            {children}
        </div>
    )
}

export default Root;